import {
  getCookie,
  setCookie,
  getCookieInt,
  deleteCookie
} from './helper/cookie.ts';

import {
  getUiValue,
  setUiValue,
  getUiValueInt
} from './helper/ui-value.ts';

(function(jQuery) {
  // add array remove function to jquery

  jQuery.arrayRemove = function(arr, elem) {
    var match = -1;

    while ((match = arr.indexOf(elem)) > -1) {
      arr.splice(match, 1);
    }
    return arr;
  };
})(jQuery);

Date.prototype.getWeek = function() {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};

String.prototype.replaceAll = function(stringToFind, stringToReplace) {
  if (stringToFind === stringToReplace) {
    return this;
  }
  var temp = this;
  var index = temp.indexOf(stringToFind);
  while (index != -1) {
    temp = temp.replace(stringToFind, stringToReplace);
    index = temp.indexOf(stringToFind);
  }
  return temp;
};

// formatting like java java.text.Messageformat '{1}-{0}'.format('abc', 'efg')  ->  'efg-abc'
if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };
}

function strToFloat(number) {
  // TODO: diese berechnung funktioniert nur bei den autonumerics mit den aktuell einstellungen...
  if (number == undefined) {
    return 0.0;
  }

  var n = number.replaceAll('.', '').replace(',', '.');
  n = parseFloat(n);
  if (typeof n !== 'undefined' && !isNaN(n)) {
    return n;
  }
  return 0.0;
}
global.strToFloat = strToFloat;

/**
 * Rounds a value to given decimals
 * preciseRound(1.229, 2) = 1.23
 *
 * @param {number} val value to round
 * @param {number} decimals decimal places to round to
 */
function preciseRound(val, decimals) {
  if (val == null || val == undefined) {
    return 0;
  }
  return parseFloat(val.toFixed(decimals));
}
global.preciseRound = preciseRound;

var ang = {};
// function to get a function in any parent scope
ang.getInParents = function($scope, obName) {
  if (
    $scope == undefined ||
    $scope == null ||
    obName == undefined ||
    obName == null
  ) {
    return null;
  }

  // sub properties have to be splitted
  if (obName.indexOf('.') != -1) {
    var parts = obName.split('.');

    // get main object
    var first = ang.getInParents($scope, parts[0]);
    if (first != null) {
      var ob = first;
      // loop through parts of object
      for (var i = 1; i < parts.length; i++) {
        if (ob == null || ob == undefined) {
          return null;
        }
        ob = ob[parts[i]];
      }
      return ob;
    }
    return null;
  }
  if ($scope[obName] != undefined) {
    return $scope[obName];
  }
  return ang.getInParents($scope.$parent, obName);
};

ang.scopeOf = function($scope, obName) {
  if ($scope == undefined || $scope == null) {
    return null;
  }

  if ($scope[obName] != undefined) {
    return $scope;
  }
  return ang.scopeOf($scope.$parent, obName);
};

ang.callInParents = function($scope, obName) {
  var func = ang.getInParents($scope, obName);
  if (func == null) {
    return function() {
      //console.debug("callInParents "+obName+" not found",$scope);
    };
  } else {
    return func;
  }
};

// safe way to apply from https://coderwall.com/p/ngisma to avoid multiple digest calls
// better use $applyAsync / $evalAsync https://www.bennadel.com/blog/2751-scope-applyasync-vs-scope-evalasync-in-angularjs-1-3.htm
ang.apply = function($scope, fn) {
  // TODO: TypeError: Cannot read property '$$phase' of null
  var phase = $scope.$root ? $scope.$root.$$phase : $scope.$$phase;
  if (phase == '$apply' || phase == '$digest') {
    if (fn) {
      $scope.$eval(fn);
    }
  } else {
    if (fn) {
      $scope.$apply(fn);
    } else {
      $scope.$apply();
    }
  }
};

/* call a function in another thread, after this thread executed*/
ang.callAfter = function(func, $scope, perfName) {
  if (!perfName) {
    perfName = 'callAfter';
  }
  app.startPerfTimer(perfName);

  if ($scope) {
    setTimeout(function() {
      app.resetPerfTimer(perfName);
      if (ang.isScopeAlive($scope)) {
        ang.apply($scope, func);
      } else {
        console.warn('scope already dead', $scope);
      }
      app.stopPerfTimer(perfName);
    }, 0);
  } else {
    setTimeout(function() {
      app.resetPerfTimer(perfName);
      func();
      app.stopPerfTimer(perfName);
    }, 0);
  }
};

(function() {
  var currentId = 1;

  ang.getUniqueId = function() {
    return currentId++;
  };
})();

//TODO: is there a better way for this?
//  das erste parameter von func ist die alte funktion
ang.overrideFunction = function(target, funcName, func) {
  var old = target[funcName];
  target[funcName] = function(a, b, c, d, e, f, g, h, i, j, k, ende) {
    if (ende != undefined) {
      alert('override function uses too many parameters. fix ang.overrideFunc');
    }
    return func(old, a, b, c, d, e, f, g, h, i, j, k);
  };
};

ang.delayedTimeout = function(object, name, func, timeout) {
  ang.clearTimeout(object, name);
  object[name] = setTimeout(func, timeout);
};

ang.clearTimeout = function(object, name) {
  if (object[name]) {
    clearTimeout(object[name]);
  }
};

ang.watchOnce = function(
  object,
  $scope,
  watch,
  func,
  ignoreFirst,
  watchObject
) {
  if (object[watch]) {
    object[watch](); // clear watch
  }

  object[watch] = $scope.$watch(
    watch,
    function() {
      if (ignoreFirst === true) {
        ignoreFirst = false;
        return;
      }
      func();
    },
    watchObject
  );
};

/* regsiters a div to be required for the scope to still be alive */
ang.registerDisplayDiv = function($scope, divSelector) {
  $scope.requiredDisplayDiv = divSelector;
};

ang.isScopeAlive = function($scope) {
  if ($scope.$requiredDisplayDiv) {
    if ($($scope.$requiredDisplayDiv).length() === 0) {
      return false;
    }
  }

  return $scope.$parent;
};
ang.tryUntilTrue = function(tempFunction, numberOfTimes) {
  var execTempFunction;
  if (numberOfTimes === undefined) {
    numberOfTimes = 10;
  }

  execTempFunction = tempFunction();
  if (!execTempFunction) {
    if (numberOfTimes > 0) {
      setTimeout(function() {
        ang.tryUntilTrue(tempFunction, numberOfTimes - 1);
      }, 1000);
    } else {
      //do nothing.
    }
  }
};
global.ang = ang;

function firstLower(str) {
  if (str && str.length > 0) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }
  return str;
}
global.firstLower = firstLower;

function firstUpper(str) {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
}
global.firstUpper = firstUpper;

ang.deleteInListById = function(listData, id) {
  for (var i = 0; i < listData.length; i++) {
    if (listData[i].id == id) {
      listData.splice(i, 1);
      return;
    }
  }
};

ang.updateList = function(listData, listObject) {
  if (listObject) {
    var found = false;
    for (var i = 0; i < listData.length; i++) {
      if (listData[i].id == listObject.id) {
        listData[i] = listObject;
        found = true;
        break;
      }
    }
    if (!found) {
      listData.push(listObject);
    }
  }
};

ang.callServiceOnce = function(service, options, callback) {
  var now = Date.now();
  let callServiceOnceLastLoadMs = now;
  service.get(options, function(result) {
    if (now == callServiceOnceLastLoadMs) {
      callback(result);
    } else {
      console.warn(
        'discarding old response',
        options,
        callServiceOnceLastLoadMs - now
      );
    }
  }); // service.get
};

ang.isDefinedDeep = function(obj, keyNames) {
  var path = _.isArray(keyNames) ? keyNames : keyNames.split('.'),
    curKeyName;

  if (path.length === 0) {
    return true;
  }

  curKeyName = path[0];
  if (!_.isUndefined(obj[curKeyName])) {
    path.shift();
    return ang.isDefinedDeep(obj[curKeyName], path);
  } else {
    return false;
  }
};

/**
 * Sets first letter to upper case
 */
if (!String.prototype.capitalize) {
  String.prototype.capitalize = function() {
    return firstUpper(this);
  };
}

global.setUiValue = setUiValue;

global.getUiValue = getUiValue;

global.getUiValueInt = getUiValueInt;

global.setCookie = setCookie;

global.getCookie = getCookie;

global.getCookieInt = getCookieInt;

global.deleteCookie = deleteCookie;

Date.prototype.isSameDay = function(pDate) {
  return (
    this.getFullYear() == pDate.getFullYear() &&
    this.getMonth() == pDate.getMonth() &&
    this.getDate() == pDate.getDate()
  );
};

// Erntejahr
Date.prototype.cropYear = function(pDate) {
  //!getMonth() is 0-Based
  if (this.getMonth() > 1 || (this.getMonth() == 1 && this.getDate() >= 15)) {
    return this.getFullYear();
  } else {
    return this.getFullYear() - 1;
  }
};

//A one-place handler to localize tooltip close button.
//Use this only if qtip was linked.
if ($.fn.qtip) {
  $.fn.qtip.defaults.events.render = function(event, api) {
    $('.qtip-close', event.currentTarget).attr(
      'title',
      app.translations['fe.common.close']
    );
  };
}

/**
 * Returns a sub property using a given path.
 *
 * @param{object} dataObject
 * @param {string} path The path to look for, e.g. "property1.property2"
 * @return {object} The object found at path or null if not found
 */
var deepGet = function(dataObject, path) {
  'use strict';
  var delimPos, next, remainingPath;

  // Base case of recursion: Last step not found
  if (!dataObject) {
    return undefined;
  }

  // Base case of recursion: No more steps to perform
  if (path.length === 0) {
    return dataObject;
  }

  // Recursion step
  delimPos = path.indexOf('.');
  if (delimPos > -1) {
    next = path.substr(0, delimPos);
    remainingPath = path.substr(delimPos + 1);
  } else {
    next = path;
    remainingPath = '';
  }
  return deepGet(dataObject[next], remainingPath);
};
global.deepGet = deepGet;

/* alphanum.js (C) Brian Huisman
 * Based on the Alphanum Algorithm by David Koelle
 * The Alphanum Algorithm is discussed at http://www.DaveKoelle.com
 *
 * Distributed under same license as original
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301  USA
 */

/*********************************************************************
 * Alphanum sort() function version - case sensitive
 *  - Slower, but easier to modify for arrays of objects which contain
 *    string properties
 *
 */
function alphanum(a, b) {
  function chunkify(t) {
    var tz = new Array();
    var x = 0,
      y = -1,
      n = 0,
      i,
      j;

    while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
      var m = i == 46 || (i >= 48 && i <= 57);
      if (m !== n) {
        tz[++y] = '';
        n = m;
      }
      tz[y] += j;
    }
    return tz;
  }

  var aa = chunkify(a);
  var bb = chunkify(b);

  for (var x = 0; aa[x] && bb[x]; x++) {
    if (aa[x] !== bb[x]) {
      var c = Number(aa[x]),
        d = Number(bb[x]);
      if (c == aa[x] && d == bb[x]) {
        return c - d;
      } else {
        return aa[x] > bb[x] ? 1 : -1;
      }
    }
  }
  return aa.length - bb.length;
}
global.alphanum = alphanum;

ang.highCharts = function(jQSelector, object) {
  Highcharts.setOptions({
    global: {
      useUTC: false
    }
  });

  if ($(jQSelector).length > 0) {
    return $(jQSelector).highcharts(object);
  }
  return null;
};

// enhanced Storage API to simplify working with localStorage in localStorageService.js
Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
};
